class TMv_SMA_PageMenus
{
	current_hover = false;

	constructor(element)
	{
		this.element = element;

		// Level 1 li tags
		this.element.querySelectorAll('.l_1').forEach( el => {
			el.addEventListener('mouseenter',this.mainMenuOver.bind(this));
			el.addEventListener('mouseleave',this.mainMenuOut.bind(this));

		});

		// Level 1 links
		this.element.querySelectorAll('.l_1 > a').forEach( el =>{
			el.addEventListener('focus',this.mainMenuOver.bind(this));

		});

		// Level 2 li tags
		this.element.querySelectorAll('.l_2').forEach( el => {
			el.addEventListener('mouseenter',this.secondaryNavOver.bind(this));
		//	el.addEventListener('mouseleave',this.secondaryNavOut.bind(this));

		});

		// Level 1 links
		this.element.querySelectorAll('.l_2 > a').forEach( el =>{
			el.addEventListener('focus',this.secondaryNavOver.bind(this));

		});

		this.element.addEventListener('keydown', this.keyHandler.bind(this));

		// $(this.element).find(' > li ')
		// 	.mouseenter((event) => this.mainMenuOver(event) )
		// 	.mouseleave((event) => this.mainMenuOut(event) );


		//$('.submenu_wrapper').mouseleave((event) => this.resetSecondaryMenus() );


		//$('.submenu_wrapper .inside > ul > li > a').mouseenter((event) => this.secondaryNavOver(event) );
	}

	/**
	 * Checks if we're loading in the mobile navigation
	 * @return boolean
	 */
	isMobile() {
		return document.body.classList.contains('mobile_navigation_showing');
	}

	removeHoverClass() {
		let current_menu = this.element.querySelector('.menu_hover_showing');
		if(current_menu)
		{
			current_menu.classList.remove('menu_hover_showing');
		}
	}

	removeSubmenuHoverClass() {
		let current_menu = this.element.querySelector('.submenu_hover_showing');
		if(current_menu)
		{
			current_menu.classList.remove('submenu_hover_showing');
		}
	}


	/**
	 * Event handler for over the main menus
	 * @param event
	 */
	mainMenuOver(event) {
		if(this.isMobile()) { return }

		this.removeHoverClass();

		let li = event.target.closest('li');
		li.classList.add('menu_hover_showing');

	}

	/**
	 * Event handler for leaving the main menus
	 * @param event
	 */
	mainMenuOut(event) {
		if(this.isMobile()) { return }

		let closest_menu = null;
		if(event.relatedTarget)
		{
			let closest_menu = event.relatedTarget.closest('.TMv_SMA_PageMenus');
		}

		// No longer in the menus,
		if(closest_menu === null)
		{
			this.removeHoverClass();
		}
	}

	/**
	 * Event handler for entering secondary nav
	 * @param event
	 */
	secondaryNavOver(event) {
		if(this.isMobile()) { return }

		this.removeSubmenuHoverClass();

		let li = event.target.closest('li');
		li.classList.add('submenu_hover_showing');

		// HEIGHT POSITIONING

		// get the parent wrapper
		let wrapper_inside = li.closest('.inside');

		// RESET : hide all the sub-sub-menus, remove heights that might have been set
		wrapper_inside.style.height  = null;

		let third_level_menu = li.querySelector('ul');
		if(third_level_menu)
		{
			// Adjust heights for positioning
			if(third_level_menu.offsetHeight > wrapper_inside.offsetHeight)
			{
				wrapper_inside.style.height = third_level_menu.offsetHeight + 'px';
			}
		}

	}


	keyHandler(event) {

		let arrow_keys = ['ArrowDown','ArrowUp','ArrowRight','ArrowLeft'];
		//console.log(event.code);
		if(arrow_keys.includes(event.code))
		{
			let active_element = document.activeElement;
			// console.log(event);
			// console.log(active_element);
			// console.log(active_element.tagName);

			// Check that we are currently in a menu
			let parent_li = active_element.parentElement;
			if(active_element.tagName === 'A' && parent_li.tagName === 'LI')
			{
				// Never let it scroll
				event.preventDefault();

				// LEVEL 1 MENU
				if(parent_li.classList.contains('l_1'))
				{
					// Needs to hop over hidden top-level menus, which are used for mobile
					if(event.code === 'ArrowLeft')
					{
						// Find one until we hit the end OR we find another l_1
						let next_parent_li = parent_li.previousElementSibling;
						while (next_parent_li !== null && !next_parent_li.classList.contains('nav_1'))
						{
							next_parent_li = next_parent_li.previousElementSibling;
						}
						if(next_parent_li)
						{
							next_parent_li.firstElementChild.focus();
						}
					}
					else if(event.code === 'ArrowRight')
					{
						// Find one until we hit the end OR we find another l_1
						let next_parent_li = parent_li.nextElementSibling;
						while (next_parent_li !== null && !next_parent_li.classList.contains('nav_1'))
						{
							next_parent_li = next_parent_li.nextElementSibling;
						}
						if(next_parent_li)
						{
							next_parent_li.firstElementChild.focus();
						}

					}
					else if(event.code === 'ArrowDown')
					{
						// Check if there is a submenu
						if(parent_li.querySelector('.submenu_wrapper'))
						{
							// Find the first element and focus on it
							parent_li.querySelector('li.l_2 a').focus();
						}
					}
				}

				// LEVEL 2 MENU - up/down moves in nav, right jumps over if it exists
				else if(parent_li.classList.contains('l_2'))
				{
					if(event.code === 'ArrowDown')
					{
						if(parent_li.nextElementSibling)
						{
							parent_li.nextElementSibling.firstElementChild.focus();
						}
					}
					else if(event.code === 'ArrowUp')
					{
						if(parent_li.previousElementSibling)
						{
							parent_li.previousElementSibling.firstElementChild.focus();
						}
						else // top of the menu, jump back up
						{
							parent_li.closest('.l_1').firstElementChild.focus();
						}
					}
					else if(event.code === 'ArrowRight')
					{
						// Check if there is a submenu
						if(parent_li.querySelector('ul.l_3_menu'))
						{
							// Find the first element and focus on it
							parent_li.querySelector('ul.l_3_menu li a').focus();
						}
					}

				}

				// LEVEL 3 MENU - up/down goes to next previous
				// Not all l_3 items have the l_3 class, so we need to reference the parent
				else if(parent_li.parentElement.classList.contains('l_3_menu'))
				{
					if(event.code === 'ArrowDown')
					{
						if(parent_li.nextElementSibling)
						{
							parent_li.nextElementSibling.firstElementChild.focus();
						}
					}
					else if(event.code === 'ArrowUp')
					{
						if(parent_li.previousElementSibling)
						{
							parent_li.previousElementSibling.firstElementChild.focus();
						}
					}
					else if(event.code === 'ArrowLeft')
					{
						parent_li.closest('.l_2').firstElementChild.focus();
					}
				}
			}

		}


	}
	// secondaryNavOut(event)
	// {
	//
	// }

	//
	// /**
	//  * Resets the secondary menus to avoid lasting effects
	//  */
	// resetSecondaryMenus()
	// {
	// 	if(this.isMobile()) { return }
	//
	// 	$('#main_menus li a').removeClass('menu_hover_showing');
	// 	//$('.submenu_wrapper').hide();
	// 	this.current_hover = false;
	//
	// 	// Ensure the original shows if necessary
	// 	$('.secondary_nav li ul').hide();
	// 	$('.secondary_nav li.highlight_menu ul').show();
	// }


	/**
	 * Show the secondary navigation with a particular ID
	 * @param id
	 */
	// showSecondaryNavForID(id)
	// {
	// 	if(this.isMobile()) { return }
	//
	// 	this.current_hover = id;
	// 	$('#main_menus li a').removeClass('menu_hover_showing');
	// 	//$('#main_menus .submenu_wrapper').hide(); // hide them all to start
	//cons
	// 	$('#main_menus_menu_item_' + this.current_hover).addClass('menu_hover_showing');
	// 	// let target_menu = $('#submenu_wrapper_' + id);
	// 	// if(target_menu.length > 0)
	// 	// {
	// 	// 	target_menu.show();
	// 	// }
	// }

}